import type { DataInterval, TickerChartDateRange } from "~types/ticker-chart";

export const ARTEMIS_PROVIDER_MARKET_DATA = "MARKET_DATA";
export enum ARTEMIS_PROVIDER_DATATYPE {
  REFERENCE = "reference",
  INTRADAY = "intraday",
  BOTH = "both",
}

export const TICKER_CHART_DATE_RANGE_TABS: TickerChartDateRange[] = [
  "1D",
  "1M",
  "6M",
  "YTD",
  "1Y",
  "5Y",
];

export const TICKER_CHART_DATE_RANGE_TABS_WITH_RT: TickerChartDateRange[] = [
  "1H",
  "1D",
  "1M",
  "6M",
  "YTD",
  "1Y",
  "5Y",
];

export const INTERVALS_BY_DATE_RANGE: Record<
  TickerChartDateRange,
  DataInterval[]
> = {
  "1H": ["1m"],
  "1D": ["1m", "5m", "15m", "30m", "1h", "4h"],
  "3D": ["1m", "5m", "15m", "30m", "1h", "4h"],
  "5D": ["1m", "5m", "15m", "30m", "1h", "4h"],
  "1W": ["1m", "5m", "15m", "30m", "1h", "4h"],
  "1M": ["1h", "4h", "1d", "1w"],
  "6M": ["1d", "1w", "1M"],
  YTD: ["1d", "1w", "1M"],
  "1Y": ["1d", "1w", "1M"],
  "5Y": ["1w", "1M", "1y"],
};

export const INTERVAL_LABELS: Record<DataInterval, string> = {
  "1m": "1 Min",
  "5m": "5 Min",
  "15m": "15 Min",
  "30m": "30 Min",
  "1h": "1 Hour",
  "2h": "2 Hour",
  "4h": "4 Hour",
  "1d": "1 Day",
  "1w": "1 Week",
  "1M": "1 Month",
  "1y": "1 Year",
};
